import { createIconComponent } from '../../factory/create-icon-component';
export const JapanIcon = createIconComponent(
  'JapanIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28261)">
      <path d="M22.9999 5H0.999878V20H22.9999V5Z" fill="#F0F0F0" />
      <path
        d="M11.9998 16.7185C14.2779 16.7185 16.1248 14.8297 16.1248 12.4998C16.1248 10.1698 14.2779 8.28107 11.9998 8.28107C9.72158 8.28107 7.87476 10.1698 7.87476 12.4998C7.87476 14.8297 9.72158 16.7185 11.9998 16.7185Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4605_28261">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
